'use strict';

const Historic = 'historic';

const Month0 = 'm0000';
const Months = [
	'm0001', 'm0002', 'm0003', 'm0004',
	'm0005', 'm0006', 'm0007', 'm0008',
	'm0009', 'm0010', 'm0011', 'm0012'
];
const Day0 = 'd0000';
const Day1 = 'd0001';
const Day2 = 'd0002';
const Day7 = 'd0007';
const Day14 = 'd0014';
const Day30 = 'd0030';

const LifeIntervals = [Day0, Month0, ...Months, Historic];
const Day7Intervals = [... daysRange(1, 7)];
const Day14Intervals = [... daysRange(8, 14)];

const Week1 = 'd0007';
const Week2 = 'd0014';
const Week3 = 'd0021';
const Week4 = 'd0028';
const Weeks = [Week1, Week2, Week3, Week4];

function * intervalsRange(prefix, startIndex, endIndex) {
	for (let i = startIndex; i <= endIndex; i++) {
		let index = i.toString().padStart(4, '0');
		yield `${prefix}${index}`;
	}
}

function * daysRange(startIndex, endIndex) {
	yield * intervalsRange('d', startIndex, endIndex);
}

function * monthsRange(startIndex, endIndex) {
	yield * intervalsRange('m', startIndex, endIndex);
}

const DailyReportIntervals = [... daysRange(1, 30)];

export {
	Day0, Month0, Months, LifeIntervals, Day7Intervals, Day14Intervals,
	DailyReportIntervals, Weeks, Historic,
	daysRange, monthsRange
};